<script setup lang="ts">
    import { CaseStatus } from '@/api/caseSearch';

    const props = defineProps<{
        currentStatus: CaseStatus;
    }>();

    const statusOrder = [
        CaseStatus.GeneratingDicoms,
        CaseStatus.ImageSegmentation,
        CaseStatus.SurgicalTemplating,
        CaseStatus.GeneratingPlan,
    ];

    const isStatusActive = (status: CaseStatus): boolean => {
        const currentIndex = statusOrder.indexOf(props.currentStatus);
        const statusIndex = statusOrder.indexOf(status);
        return statusIndex <= currentIndex;
    };
</script>

<template>
    <div class="state-tracker d-flex align-center justify-start gap-3 ml-2 mb-4">
        <div
            v-for="status in statusOrder"
            :key="status"
            class="status-circle"
            :class="{ 'status-active': isStatusActive(status) }"
        />
    </div>
</template>

<style scoped lang="scss">
.state-tracker {
    gap: 10px;

    .status-circle {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: rgb(var(--v-theme-grey-light-1));
        transition: background-color 0.3s ease;

        &.status-active {
            background-color: rgb(var(--v-theme-primary));
        }
    }
}
</style>
